<div class="wrapper flex gap-[20px] w-full">
  <app-primary-button
    (handleClick)="save()"
    [isDisabled]="!isFormDirty"
    class="save-button"
    >Save
  </app-primary-button>
  <div
    [class.disabled]="disableAddMenu"
    [matMenuTriggerFor]="add"
   
    class="action-button add-button"
    >
    <mat-icon class="add" svgIcon="plus" />
  </div>
  <div
    [class.disabled]="disableOptionMenu" [matMenuTriggerFor]="menu"
   
    class="action-button menu-button"
    >
    <mat-icon class="menu">more_horiz</mat-icon>
  </div>
</div>
<input
  #fileInput
  (change)="onFileSelected($event)"
  accept=".png, .jpg, .jpeg, .mp4"
  class="hidden"
  multiple="multiple"
  type="file" />
<mat-menu #add="matMenu">
  @for (option of addMenuOptions; track option) {
    <button
      (click)="option.handler()"
      mat-menu-item
      >
      <div class="add-menu-item flex justify-start items-center">
        <div class="flex justify-center items-center h-[48px]">
          <mat-icon [svgIcon]="option.icon" class="menu-icon" />
        </div>
        <div class="menu-label">{{ option.label }}</div>
      </div>
    </button>
  }
</mat-menu>
<mat-menu #menu="matMenu">
  <button
    (click)="delete()"
    mat-menu-item
    >
    <mat-icon svgIcon="trash" />
    Delete
  </button>
</mat-menu>
